import React from 'react';
import { useTranslation } from '../hooks/useTranslation';
import ModalPortal from './ModalPortal';

type ContactModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const ContactModal: React.FC<ContactModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <ModalPortal>
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white">
            {t('contact.title')}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        
        <div className="space-y-4">
          <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed">
            {t('contact.description')}
          </p>
          
          <div className="border-t border-gray-200 dark:border-gray-700 pt-4">
            <div className="flex items-center space-x-3">
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  {t('contact.email')}
                </p>
                <a
                  href="mailto:info@lenz3.com"
                  className="text-sm text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300 transition-colors"
                >
                  {t('contact.emailAddress')}
                </a>
              </div>
            </div>
            <div className="flex items-center mt-5 space-x-3">
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  {t('contact.contactUs')}
                </p>
                <p
                  dir="ltr"
                  className="text-sm mt-2 text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300 transition-colors"
                >
                  {t('contact.mobile')}
                </p>
                <p
                  dir="ltr"
                  className="text-sm mt-1 text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300 transition-colors"
                >
                  {t('contact.phone')}
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-6 flex justify-start">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md transition-colors text-sm font-medium"
          >
            {t('contact.close')}
          </button>
        </div>
      </div>
    </div>
    </ModalPortal>
  );
};

export default ContactModal;